import React from 'react';
import styles from './LineSeparator.mscss';

interface OwnProps {
    title: string | React.ReactNode;
}

type Props = OwnProps;

const LineSeparator = React.memo<Props>(
    ({ title }) => {
        return (
            <div className={styles.LineSeparator}>
                <div className={styles.LineSeparator__line} />
                <div className={styles.LineSeparator__lineContent}>
                    <h4 className={styles.LineSeparator__lineContent__text}>{title}</h4>
                </div>
                <div className={styles.LineSeparator__line} />
            </div>
        );
    },
);

LineSeparator.displayName = 'LineSeparator';

export default LineSeparator;

